import React, { useEffect, useState, useContext } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import {
  Container,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Stack,
  Button,
  IconButton,
  Badge,
  Tooltip,
  Stepper,
  Step,
  Paper,
  TextField,
  Alert,
  StepLabel,
  Box,
  Card,
  CardContent,
  Chip,
  InputAdornment
} from '@mui/material';

import {
  ExpandMore,
  Visibility,
  Delete,
  PictureAsPdf,
  Add,
  CheckCircle,
  Upload,
  WarningAmber
} from '@mui/icons-material';

import fascicoloApi from '../../api/fascicoloApi';
import documentoApi from '../../api/documentoApi';
import logprocessoApi from '../../api/logprocessoApi';
import { AuthContext } from '../../auth/AuthContext';
import ProtectedAction from '../../components/ProtectedAction';
import { formatDate } from '../../utils/dateFormatter';
import FascicoloChat from '../../components/FascicoloChat';
import BackButtonDesktop from '../../components/BackButtonDesktop';
import DocumentoFascicoloTableMobile from '../../components/DocumentoFascicoloTableMobile';

const tipiDocumento = [
  'MULTA',
  'PAGOPA',
  'RATEIZZAZIONE_ADE',
  'ROTTAMAZIONE',
  'AMA',
  'ACCERTAMENTO_TARI',
  'F24',
  'FF24PREDETERMINATO',
  'TARI',
  'INTIMAZIONEPAG_AGRISC',
  'BOLLOAUTO',
  'INARCASSA',
  'FATTURA_PASSIVA',
  'FATTURA_ATTIVA',
  'ALTRO'
];

export default function FascicoloDetailPageMobile() {

  const { id } = useParams();
  const { user } = useContext(AuthContext);
  const navigate = useNavigate();

  const pageSize = 10000;

  const [contribuente, setContribuente] = useState({});
  const [documenti, setDocumenti] = useState([]);
  const [richiesteNonEvase, setRichiesteNonEvase] = useState([]);
  const [fascicoloId, setFascicoloId] = useState(null);

  const [jobLogs, setJobLogs] = useState([]);
  const [jobDocsState, setJobDocsState] = useState({});

  const [page, setPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);

  /* ========================= INIT ========================= */

  useEffect(() => {
    const fetchFascicolo = async () => {
      try {
        const res = id
          ? await fascicoloApi.getFascicoloByContribuenteId(id)
          : await fascicoloApi.getMyFascicolo();

        setFascicoloId(res.data.id);
        setContribuente(res.data.contribuente);

        fetchDocumentiFascicolo(res.data.id, 0);
        fetchRichiesteNonEvase(res.data.id);
        fetchJobLogs(res.data.id);

      } catch (err) {
        console.error(err);
      }
    };

    fetchFascicolo();
  }, [id]);

  /* ========================= API ========================= */

  const fetchDocumentiFascicolo = async (fid, page) => {
    try {
      const params = { page, size: pageSize, sort: `dataUpload,DESC` };
      const res = await fascicoloApi.getDocumentiFascicoloPaginated(fid, params);

      setDocumenti(res.data.content || []);
      setTotalPages(res.data.totalPages || 0);
      setPage(res.data.number || 0);

    } catch (err) {
      console.error(err);
    }
  };

  const fetchRichiesteNonEvase = async (fid) => {
    try {
      const res = await fascicoloApi.getRichiesteNonEvase(fid);
      setRichiesteNonEvase(res.data);
    } catch (err) {
      console.error(err);
    }
  };

const fetchJobLogs = async (fid) => {
  try {
    const res = await logprocessoApi.getByFascicolo(fid);

    const logsWithAnomalies = res.data.filter(
      l => l.anomalie && l.anomalie !== "{}"
    );

    setJobLogs(logsWithAnomalies);

    const initialState = {};

    logsWithAnomalies.forEach((job, jobIndex) => {

      let docs = {};
      let anomalieMap = {};

      try {
        docs = JSON.parse(job.testoplain || "{}");
      } catch {
        docs = {};
      }

      try {
        anomalieMap = JSON.parse(job.anomalie || "{}");
        console.log("anomaliemap",anomalieMap);
      } catch {
        anomalieMap = {};
        console.log("anomaliemap",anomalieMap);
      }

      initialState[jobIndex] = {};

      Object.entries(docs).forEach(([docKey, docStr]) => {

        // 👉 filtro: se NON esiste nell'anomalie → SKIP
        if (!anomalieMap[docKey]) {
          return;
        }

        let doc = {};
        try {
          doc = JSON.parse(docStr);
        } catch {
          doc = {};
        }

        let anomalie = [];
        try {
          anomalie = JSON.parse(anomalieMap[docKey]);
          console.log("docKey",docKey);
          console.log("anomalie",anomalie);
        } catch {
          anomalie = [];
        }

        initialState[jobIndex][docKey] = {
          documento: doc || {},
          scadenze: doc.scadenze || [],
          anomalie: anomalie.anomalie
        };
      });

    });
    console.log("initialState",initialState);
    setJobDocsState(initialState);

  } catch (err) {
    console.error(err);
  }
};

  /* ========================= ACTIONS ========================= */

  const handleNuovoDocumento = () => {
    navigate(`/fascicolo/${fascicoloId}/documento/create`);
  };

  const handleCreaScadenze = (doc) => {
    navigate(`/contribuenti/${contribuente.id}/documenti/upload`, {
      state: { documentoFascicoloId: doc.id }
    });
  };

  const handleDelete = async (idDoc) => {
    await fascicoloApi.deleteDocumento(idDoc);
    setDocumenti(prev => prev.filter(d => d.id !== idDoc));
  };

  const handleDownload = async (idDoc) => {
    const res = await fascicoloApi.downloadDocumento(idDoc);
    const url = URL.createObjectURL(new Blob([res.data]));
    window.open(url, '_blank');
  };

    const handleCambiaStatoRichiesta = async (richiestaId, stato) => {
      try {
        await fascicoloApi.changeStatoRichiesta(richiestaId, stato);
        setRichiesteNonEvase(
          richiesteNonEvase.map(r => (r.id === richiestaId ? { ...r, stato } : r))
        );
      } catch (err) {
        console.error(err);
      }
    };

    const handleCreaDocumentoDaRichiesta = (richiestaId, tipo) => {
      navigate(`/fascicolo/${fascicoloId}/documento/create`, { state: { richiestaId, tipo } });
    };
  /* ========================= SCADENZE JOB ========================= */

  const handleChangeScadenza = (jobIndex, docKey, index, field, value) => {
    setJobDocsState(prev => {
      const updatedJob = { ...prev[jobIndex] };
      const updatedDoc = { ...updatedJob[docKey].documento };
      const updatedScadenze = [ ...updatedJob[docKey].scadenze ];
      updatedScadenze[index][field] = value;

      updatedDoc.scadenze = updatedScadenze;
      updatedJob[docKey].documento = updatedDoc;
      updatedJob[docKey].scadenze = updatedScadenze;

      return { ...prev, [jobIndex]: updatedJob };
    });
  };

  const handleConfirmSave = async (jobId, docKey, doc) => {
    try {
      const params = { docKey: `${docKey}` };
      await documentoApi.create(doc,docKey);
      await logprocessoApi.aggiorna(jobId,params);
    } catch (err) {
      console.error(err);
    } finally {
      fetchJobLogs(fascicoloId);
    }
  };
  /* ========================= RENDER ========================= */

  return (
    <Container sx={{ mt: 2, mb: 6 }}>

      <BackButtonDesktop />

      <Typography variant="h5" sx={{ mb: 2 }}>
        Fascicolo di {contribuente.nome} {contribuente.cognome}
      </Typography>
      {/* Richieste Documento */}
      <Stack spacing={2}>
        <Stack direction="row" justifyContent="space-between" alignItems="center">
          <Typography variant="h6">Richieste Documento</Typography>
          <ProtectedAction user={user} roles={['ADMIN', 'STUDIO']} contractState={user.statoContratto}>
            <Button
              variant="contained"
              onClick={() => navigate(`/fascicolo/${fascicoloId}/richieste/create`)}
            >
              Nuova richiesta
            </Button>
          </ProtectedAction>
        </Stack>

        {richiesteNonEvase.map(r => (
          <Accordion key={r.id}>
            <AccordionSummary expandIcon={<ExpandMore />}>
              <Stack direction="row" spacing={1} sx={{ width: '100%', justifyContent: 'space-between' }}>
                <Typography>{r.tipoDocumento} - Stato: {r.stato}</Typography>
              </Stack>
            </AccordionSummary>
            <AccordionDetails>
              <Typography variant="body2">Richiesto da: {r.richiestoDa?.nome} {r.richiestoDa?.cognome}</Typography>
              <Typography variant="body2">Data richiesta: {r.dataRichiesta}</Typography>
              <Stack direction="row" spacing={1} sx={{ mt: 1, flexWrap: 'wrap' }}>
                {r.stato === 'RICHIESTO' && (
                  <Button
                    size="small"
                    variant="outlined"
                    onClick={() => handleCreaDocumentoDaRichiesta(r.id, r.tipoDocumento)}
                  >
                    Carica Documento
                  </Button>
                )}
                {r.pdfPath && (
                  <Button size="small" onClick={() => handleDownload(r.id, r.pdfPath)}>
                    Apri PDF
                  </Button>
                )}
              </Stack>
            </AccordionDetails>
          </Accordion>
        ))}
      </Stack>
      {/* ================= DOCUMENTI ================= */}
        <Card sx={{ mb: 3 }}>

          <CardContent>

            <DocumentoFascicoloTableMobile
              documenti={documenti}
              contribuenteId={contribuente?.id}
              fascicoloId={fascicoloId}
              onDownload={handleDownload}
              onDelete={handleDelete}
            />

          </CardContent>

        </Card>

      {/* ================= JOB ================= */}
      <Card sx={{ mb: 3 }}>
        <CardContent>

          <Typography variant="h6" sx={{ mb: 2 }}>
            Elaborazioni con anomalie
          </Typography>

          {jobLogs.map((job, jobIndex) => {
            const docs = Object.entries(JSON.parse(job.testoplain))
              .map(([docKey, docStr]) => [docKey, JSON.parse(docStr)]);

            return (
              <Paper key={jobIndex} sx={{ p: 3, mb: 3, borderRadius: 2 }}>

                <Typography variant="subtitle2" sx={{ mb: 2 }}>
                  Job del {formatDate(job.dataInizio)}
                </Typography>

                <Stepper orientation="vertical" activeStep={-1}>
                {docs.map(([docKey, doc]) => {
                  const docState = jobDocsState[jobIndex]?.[docKey];

                  if (!docState) return null;

                  return (
                    <Step key={docKey} expanded>
                      <StepLabel>
                        Documento {doc.numeroDocumento}
                      </StepLabel>

                      <Typography color="error">
                        <WarningAmber /> Anomalie: {docState.anomalie?.join(", ")}
                      </Typography>

                      <Box sx={{ ml: 3, mt: 2 }}>
                        {docState.documento.scadenze.map((s, index) => (
                          <Box key={index} sx={{ mb: 2 }}>
                            <Typography variant="body2">Rata {s.numerorata}</Typography>

                            <TextField
                              fullWidth
                              label="Data scadenza"
                              type="date"
                              value={s.dataScadenza || ''}
                              onChange={(e) =>
                                handleChangeScadenza(jobIndex, docKey, index, 'dataScadenza', e.target.value)
                              }
                              InputLabelProps={{ shrink: true }}
                              sx={{ mt: 1, mb: 1 }}
                            />

                               <TextField
                                  fullWidth
                                  label="Importo"
                                  type="number"
                                  value={s.importo || ''}
                                  onChange={(e) => handleChangeScadenza(jobIndex, docKey,index, 'importo', e.target.value)}
                                  inputProps={{ inputMode: "decimal", step: "0.01" }}
                                  InputProps={{
                                    startAdornment: <InputAdornment position="start">€</InputAdornment>,
                                  }}
                                  sx={{ mb: 1 }}
                                />

                                <TextField
                                  fullWidth
                                  label="Codice pagamento"
                                  value={s.codiceModuloPagamento || ''}
                                  onChange={(e) => handleChangeScadenza(jobIndex, docKey,index, 'codiceModuloPagamento', e.target.value)}
                                />

                                <TextField
                                  fullWidth
                                  label="QR code"
                                  value={s.qrcode || ''}
                                  onChange={(e) => handleChangeScadenza(jobIndex, docKey,index, 'qrcode', e.target.value)}
                                />
                          </Box>
                        ))}

                        <Button
                          variant="contained"
                          color="success"
                          sx={{ mt: 2 }}
                          onClick={() => handleConfirmSave(job.id, docKey, docState.documento)}
                        >
                          Conferma e Salva
                        </Button>
                      </Box>
                    </Step>
                  );
                })}

                </Stepper>

              </Paper>
            );
          })}

        </CardContent>
      </Card>

      {fascicoloId && contribuente.studio && user.chatisactive && (
        <FascicoloChat fascicoloId={fascicoloId} />
      )}

    </Container>
  );
}
